// extracted by mini-css-extract-plugin
export default {"frameGradient":"StickToBottom_frameGradient__ZYwo1","stickBottom":"StickToBottom_stickBottom__RYf77","keyboardOpen":"StickToBottom_keyboardOpen__eeJ8e"};